export const TAB = {
  TASKS: 'tasks',
  EVENTS: 'events'
};
